module.exports = __webpack_public_path__ + "static/james-profile-pic-b0b6b417002b22b21d6b6e3937004b94.jpg";